import type { TFunction } from 'i18next'
import type { AssignedDomain } from '../types/permissions.types'

export const isAssigned = (domain: AssignedDomain) =>
  domain.roles.some((role) => role.assigned === 'set')

// Held only through a group or a role set in another domain (Super Admin, say):
// nothing is set directly in this domain.
export const isInherited = (domain: AssignedDomain) =>
  !isAssigned(domain) &&
  domain.roles.some((role) => role.assigned === 'inferred')

// These take a plain TFunction: the iam lib is type-checked in apps whose
// translations do not declare these keys, and only admin-dashboard renders them.

export const inheritedCount = (count: number, t: TFunction): string =>
  t('drawer.accounts.inheritedCount', { count })

export const inheritedLabel = (t: TFunction): string =>
  t('drawer.accounts.inherited')
